import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtDto } from "../../../models/court/dto/court.dto";

export const GET_COURT_QUERY_KEY = (id: number) => ['courts', id];
export const useGetCourt = (id: number) => {
    const client = useApiClient();
    return useQuery({
        staleTime: Infinity,
        cacheTime: Infinity,
        queryKey: GET_COURT_QUERY_KEY(id),
        queryFn: () => client.fetchApi<CourtDto, {}>({ endpoint: `courts/${id}`, method: 'GET' }),
        // Guard against a NaN/undefined id (e.g. a missing `court` URL param):
        // never fire `courts/NaN`, which the API now rejects with a 400.
        enabled: Number.isInteger(id),
    });
};